<template>
  <v-flex
    v-if="!loading"
    xs8
    offset-xs2
    align-self-center
    justify-center
  >
  <div>
    <v-container fill-height fluid>
    <v-row>
      <v-flex xs3 class="mr-2">
        <Search
          v-model="filters.search"
          :label="$t('SEARCH')"
          prepend-icon="search"
          :delay="500"
        />
      </v-flex>
      <v-spacer></v-spacer>
      <v-btn
        v-if="can('create zones')"
        @click="showZoneModal(0)"
        color="primary"
        dark
        class="mb-2"
      >{{ $t("NEW") }}
      </v-btn>
    </v-row>
    </v-container>
    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :options.sync="pagination"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:item.name="{ item }">
        <router-link :to="{ name: routeName.ZONE_SHOW, params: { id: item.id } }">
            {{ item.name }}
        </router-link>
      </template>
      <template v-slot:item.updated_at="{ item }">
            {{ item.updated_at | timeFormat }}
      </template>
      <template v-slot:item.actions="{ item }">
            <v-layout row wrap>
              <v-flex class="text-no-wrap">
                <v-btn
                  icon
                  color="blue"
                  v-if="can('edit zones')"
                  @click="showZoneModal(item.id)"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  v-if="can('delete zones')"
                  icon
                  color="red"
                  @click="deleteZone(item.id)"
                >
                  <v-icon>cancel</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
      </template>
    </v-data-table>
    <Paginator
      :total-items="totalItems"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.itemsPerPage"
      @change="fetchZones"
    />
  </div>
  </v-flex>
  <Loader v-else/>
</template>
<script>

  import { mapActions } from 'vuex';

  import { zonesService } from '../../utils/services/zones.service';
  import Search from '../../components/shared/Inputs/Search';
  import Loader from '../../components/shared/Loader';
  import ZoneModal from '../../components/modals/Zones/ZoneModal';
  import Paginator from '../../components/shared/Paginator';

  export default {
    name: 'ZoneList',
    components: { Search, Loader, Paginator },
    data() {
      return {
        loading: false,
        items: [],
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['name'],
        },
        headers: [
          {
            text: this.$t('fields.id'),
            align: 'left',
            value: 'id',
          },
          { text: this.$t('fields.name'), value: 'name' },
          { text: this.$t('fields.updated_at'), value: 'updated_at' },
          { text: this.$t('fields.actions'), value: 'actions', sortable: false, align: 'center' },
        ],
        filters: {
          search: null,
        },
      };
    },
    computed: {
      requestFilters() {
        const filters = {
          search: this.filters.search,
        };
        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },
    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),
      async fetchZones(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return zonesService.index({
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },
      async showZoneModal(id) {
        this.showModal({
          component: ZoneModal,
            data: {
              stored: {
                id,
              },
          },
          options: {
            title: this.$t('ZONE'),
            onSave: (
              form,
              error,
            ) => zonesService.save(form)
            .then(() => {
              this.hideModal({});
              this.showToast({ type: 'success', message: this.$t('SAVED') });
            })
            .catch(error => {
              this.handleError(error, this.errors);
            })
            .finally(() => {
              this.fetchZones(this.pagination.page);
            }),
          },
        });
      },
      async deleteZone(id) {
          this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return zonesService.remove(id)
              .then(() => {
                this.showToast({ type: 'success', message: this.$t('DELETED') });
                this.fetchZones(this.pagination.page);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
      },
    },
    async created() {
      await this.fetchZones(this.pagination.page);
    },
    watch: {
      filters: {
        deep: true,
        handler() {
          this.fetchZones(1);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchZones(1);
          }
        },
      },

    },
  };
</script>
